module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.8185/js/img/CRM.svg"